/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Marketing_CopyrightInputs */

const en_marketing_copyright = /** @type {(inputs: Marketing_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} JXD Ltd`)
};

const es_marketing_copyright = /** @type {(inputs: Marketing_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} JXD Ltd`)
};

const fr_marketing_copyright = /** @type {(inputs: Marketing_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} JXD Ltd`)
};

/**
* | output |
* | --- |
* | "© {year} JXD Ltd" |
*
* @param {Marketing_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_copyright = /** @type {((inputs: Marketing_CopyrightInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_CopyrightInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_copyright(inputs)
	if (locale === "es") return es_marketing_copyright(inputs)
	return fr_marketing_copyright(inputs)
});